export default {
    email: RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.'
        + '[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'),
    oneSpecialChar: RegExp('[!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~”]+'),
    oneDigitChar: RegExp('\\d+'),
    oneLowerChar: RegExp('[a-z]+'),
    oneUpperChar: RegExp('[A-Z]+'),
    noSpaces: RegExp('^[\\S]+$'),
    phoneRules: RegExp('^([+]){0,1}[0-9]+$'),
    noCyrillic: RegExp('^[^а-я]+$'),
};
